"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = List;

var _react = _interopRequireDefault(require("react"));

var _useLDflexList = _interopRequireDefault(require("../hooks/useLDflexList"));
/** Displays a list of items matching a Solid LDflex expression. */


function List(_ref) {
  var src = _ref.src,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? Infinity : _ref$limit,
      _ref$filter = _ref.filter,
      filter = _ref$filter === void 0 ? function () {
    return true;
  } : _ref$filter,
      _ref$container = _ref.container,
      container = _ref$container === void 0 ? function (items) {
    return _react.default.createElement("ul", null, items);
  } : _ref$container,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? function (item, index) {
    return _react.default.createElement("li", {
      key: index
    }, "".concat(item));
  } : _ref$children;
  var items = (0, _useLDflexList.default)(src).filter(filter).slice(offset, +offset + +limit).map(children);
  return container ? container(items) : items;
}